import React from "react";
import Welcome from "./home-content/welcome";
import Service from "./home-content/service";
import Classes from "./home-content/classes";
import Inscription from "./home-content/inscription";
import InscriptionPro from "./home-content/inscription-pro";
import Newsletter from "./home-content/newsletter";

import SuccessCarousel from "./home-content/success-carousel";

const Landing = () => {
  return (
    <div className="w-full bg-[#fcfcfc] overflow-x-hidden">
      <Welcome />
      <Service />
      <Classes />
      <Inscription />
      <SuccessCarousel />
      <Newsletter />
    </div>
  );
};

export default Landing;
